import axios from 'axios';
import _ from 'lodash';

export const getPlatformList = () => {
  return axios.get('/cms/user/platform/list').then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data.users', []);
    }
  });
};

export const getPlatformDefaultList = () => {
  return axios.get('/cms/user/default/list').then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data', []);
    }
  });
};

export const createPlatform = (payload) => {
  return axios.post(`/cms/user/platform`, payload).then((res) => res.data.data);
};

export const updatePlatformById = (id, payload) => {
  return axios.put(`/cms/user/platform/${id}`, payload).then((res) => res.data.data);
};

export const exportPlatformList = async (platformCodes) => {
  const formData = new FormData();
  platformCodes.forEach((code) => formData.append('platform_codes', code));

  try {
    const res = await axios.post('/cms/user/platform/export', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (res.data.code === 0) {
      const downloadUrl = _.get(res, 'data.data.url');
      if (downloadUrl) {
        // Redirect to download
        window.open(downloadUrl, '_blank');
      }
    }
  } catch (error) {
    console.error('Export failed:', error);
  }
};

export const importPlatformList = (file) => {
  const formData = new FormData();
  formData.append('file', file);

  return axios
    .post('/cms/user/platform/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => {
      if (res.data.code === 0) {
        return _.get(res, 'data.data', []);
      } else {
        throw new Error('Import failed with non-zero code.');
      }
    });
};

export const getProviderListByPlatformId = (id) => {
  return axios.get(`/cms/user/platform/${id}/provider/list`).then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data.providers', []);
    }
  });
};

export const getProviderByPlatformId = (platformId, providerId) => {
  return axios.get(`/cms/user/platform/${platformId}/provider/${providerId}`).then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data', null);
    }
  });
};

export const createProviderByPlatformId = ({ platformId, providerId }, payload) => {
  return axios
    .post(`/cms/user/platform/${platformId}/provider/${providerId}`, payload)
    .then((res) => res.data.data);
};

export const updateProviderByPlatformId = ({ platformId, providerId }, payload) => {
  return axios
    .put(`/cms/user/platform/${platformId}/provider/${providerId}`, payload)
    .then((res) => res.data.data);
};

export const generateTokenByPlatformId = (platformId) => {
  return axios.get(`/cms/user/platform/${platformId}/generate_token`).then((res) => res.data.data);
};

export const callProviderUpdateBetLimit = ({ platformId, providerId }) => {
  return axios
    .get(`/cms/user/platform/${platformId}/provider/${providerId}/call_update_bet_limit`)
    .then((res) => res.data.data);
};

export const changePlatformBetLimit = ({ platformId, providerId }, payload) => {
  return axios
    .put(`/cms/user/platform/${platformId}/provider/${providerId}/bet_settings`, payload)
    .then((res) => res.data.data);
};
